// extracted by mini-css-extract-plugin
export default {"container":"vX-z","title":"wX-z","link":"xX-z"};